import { WP_URL, COUNTRY_KEY, LANGUAGE_KEY } from "../settings";

$(() => {
  $("#footerSearch").on("submit", (ev) => {
    ev.preventDefault();
    let value = $("input[type='text'][name='footer-search']", $(ev.currentTarget)).val();
    if (!value) return;
    const urlToSearch = `${WP_URL}${COUNTRY_KEY.toLocaleLowerCase()}/${LANGUAGE_KEY.toLocaleLowerCase()}/?s=${value}`;
    window.open(urlToSearch);
  });
});
